// extracted by mini-css-extract-plugin
export default {"HowToInstallTextsContainer":"HowToInstallTexts_HowToInstallTextsContainer__83eaa","howtoinstalltext":"HowToInstallTexts_howtoinstalltext__uIA2H"};